// extracted by mini-css-extract-plugin
export default {"component":"Application_component__hIsV4"};